__turbopack_context__.v({
  "email": "styles-module-scss-module__6e0lgG__email",
});
